import LockedFeatureModal, {
  LOCKED_FEATURE_CONTENT_V1,
} from 'modules/membership/plans/LockedFeatureModal';
import LockedFeatureModalV2, {
  LOCKED_FEATURE_CONTENT_V2,
} from 'modules/membership/plans/LockedFeatureModalV2';
import {createContext, useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router';

const LockedFeatureContext = createContext({});

function LockedFeatureProvider(props) {
  const {children} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [persist, setPersist] = useState(false);
  const [type, setType] = useState('verification');
  const {pathname} = useLocation();

  function toggleModal(type, persist, force) {
    if (type) {
      setPersist(persist);
      setType(type || 'verification');
      setIsOpen((prev) => force || !prev);
    }
  }

  // close path when user goes to other page
  useEffect(() => {
    if (isOpen) setIsOpen(false);
  }, [pathname]);

  const redirect = pathname.replace(/^\//, '');
  return (
    <LockedFeatureContext.Provider value={{toggleLock: toggleModal}}>
      {children}

      {type in LOCKED_FEATURE_CONTENT_V1 && (
        <LockedFeatureModal
          isOpen={isOpen}
          toggle={toggleModal}
          redirect={redirect}
          type={type}
          persist={persist}
        />
      )}

      {type in LOCKED_FEATURE_CONTENT_V2 && (
        <LockedFeatureModalV2
          type={type}
          isOpen={isOpen}
          persist={persist}
          redirect={redirect}
          toggle={toggleModal}
        />
      )}
    </LockedFeatureContext.Provider>
  );
}

const useLockedFeature = () => useContext(LockedFeatureContext);

export {LockedFeatureContext, LockedFeatureProvider, useLockedFeature};
